import React from 'react';
import { Box, Typography } from '@mui/material';
import LoginTab from '../../components/loginTab/LoginTab';
import { useDispatch } from 'react-redux';
import {
   // logOut,
   resetLogout,
} from '../../components/app/features/auth/AuthSlice';

const Login = () => {
   const dispatch = useDispatch();

   React.useEffect(() => {
      dispatch(resetLogout());
   }, []);

   return (
      <Box sx={{paddingX:{ xs:'5px', sm:'10px' }}}>
         <Box  sx={{ fontSize: { xs: '1.5rem', md: '2.3rem' }, color:'#333333', }}
            fontWeight={600}
           className="pageHeader font-cormorant">
            Hi, Welcome Back
         </Box>
         <Typography  sx={{ fontSize: { xs: '0.7rem', md: '1rem' } }}
            fontWeight={400}
            color="#58564d">
            Please log in into your account
         </Typography>
         <LoginTab />
      </Box>
   );
};

export default Login;
